import Blogs from "../../components/Blogs";
import { blogs } from "../../data/Data";
import { filterSeasonalContent } from "../../config/seasons";
import Seo from "../../components/Seo";


import { routeMeta } from "../../seo/staticRoutes";
export default function BlogsPage(){


    return(
        <>
        <Seo {...routeMeta("/blogs")} />
        <Blogs
          blogsData={filterSeasonalContent(blogs)}
          isBlogsPage
        />
        
        </>

    )
}